import type { Networkish } from "@/types";
import { useMemo } from "react";

import useApi from "@/hooks/api/useApi";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { Address } from "viem";

export type SupWeb3UserAddressType = "EOA" | "Normal Contract" | "Gnosis Safe Contract" | "CREATE2 Contract";

interface ResponseAddressType {
  addressType: SupWeb3UserAddressType;
}

export default function useAddressType(chainId: Networkish | undefined = undefined, address: Address | undefined = undefined) {
  const userAddress = useWeb3UserAddress();

  const addressToCheck = useMemo(() => address || userAddress, [address, userAddress]);

  const url = useMemo(() => {
    if (!addressToCheck || !chainId) {
      return undefined;
    }
    return `/address/type/${addressToCheck}/?chainID=${chainId}`;
  }, [addressToCheck, chainId]);

  const { data, isLoading, isError, error } = useApi<SupWeb3UserAddressType, ResponseAddressType>(
    {
      path: url || "",
      api: "v2",
    },
    {
      enabled: url !== undefined,
      strategy: "fully-cached",
      select: data => data.addressType.trim() as SupWeb3UserAddressType,
    }
  );

  return {
    data,
    error,
    isLoading,
    isError,
  };
}
